
import { getCountryByValue } from '@/data/regions';

export const getStateName = (countryId: string, stateId: string, language: string = 'de'): string => {
  const countryData = getCountryByValue(countryId);
  if (!countryData) {
    return stateId;
  }

  const stateData = countryData.regions.find(region => 
    region.name[language === 'de' ? 'de' : 'en'].toLowerCase() === stateId.toLowerCase() ||
    region.value.toLowerCase() === stateId.toLowerCase()
  );

  return stateData ? stateData.name[language === 'de' ? 'de' : 'en'] : stateId;
}; 
